module.exports = __webpack_public_path__ + "7312587c99043faa1b3eb7003f44683a.webp";


//////////////////
// WEBPACK FOOTER
// ./apps/www.dawnofwar.com/src/static/img/gorgutz-panel-420.webp
// module id = 379
// module chunks = 0